import React, { useContext, useState, useMemo, useCallback, memo } from "react";
import { Row } from "reactstrap";
import { DF_OT0016Context } from "../context";
import TranspaleStringToComponente from "../../../components/Dynamic/TranspaleStringToComponente";
import TableSimple from "../../../components/Dynamic/TableSimple";
import ModalIframePage from "../../../components/Common/ModalIframePage";

const PROC_NAME_GRID = "FRONT_Workspace_DF_OT0016_Tabela_Grid_V16";
const ROTA_NOVO = "/DF_OT0019";
const IDIOMA_PADRAO = "pt-BR";
const PAR_PAGINA = "1";
const PAR_REGISTROS_PAGINA = "100";

const COLUMNS_LIST = [
  { field: "ID", header: "ID", width: "8%", sort: true },
  { field: "Empresa_Origem", header: "Empresa Origem", sort: true, hasImage: true },
  { field: "Empresa_Destino", header: "Empresa Destino", sort: true, hasImage: true },
  { field: "Categoria", header: "Categoria", sort: true },
  { field: "Coluna_Funcoes", header: "", width: "5%", hasImage: true, Export: false },
];

const INITIAL_FILTER_STATE = [{}];

function GridBody() {
  const {
    userProfile,
    paramsOnFilter,
    setParamsOnFilter,
    triggerOnFilter,
    setTriggerOnFilter,
    navigate,
  } = useContext(DF_OT0016Context);

  const [preFilter, setPreFilter] = useState(INITIAL_FILTER_STATE);
  const [showGrid, setShowGrid] = useState(false);

  const [triggerType, setTriggerType] = useState("");
  const [openModalVisualization, setOpenModalVisualization] = useState(false);

  const userId = userProfile?.ID_Usuario ?? 0;

  const getFilterValue = useCallback(
    (key) => {
      const item = preFilter[0]?.[key];
      if (item === undefined || item === null) return "";
      return typeof item === "object" && "value" in item ? item.value : item;
    },
    [preFilter]
  );

  const idOrigem = getFilterValue("Filtro_ID_Empresa_Origem");
  const hasOrigem = Boolean(idOrigem);

  const handleFilterChange = useCallback((filters) => {
    setPreFilter((state) => {
      const currentState = state[0] || {};

      const isOrigemChanging =
        "Filtro_ID_Empresa_Origem" in filters &&
        filters.Filtro_ID_Empresa_Origem !== currentState.Filtro_ID_Empresa_Origem;

      const updatedState = {
        ...currentState,
        ...filters,
        ...(isOrigemChanging && { Filtro_ID_Categoria: "" }),
      };

      return [updatedState];
    });
  }, []);

  const handleNew = useCallback(() => {
    navigate?.(ROTA_NOVO);
  }, [navigate]);

  const handleTriggers = useCallback((trigger) => {
    setTriggerType(trigger);
    setOpenModalVisualization(true);
  }, []);

  const handleSearch = useCallback(() => {
    setParamsOnFilter(preFilter);
    setTriggerOnFilter(true);
    setShowGrid(true);
  }, [preFilter, setParamsOnFilter, setTriggerOnFilter]);

  const procParams = useMemo(
    () =>
      JSON.stringify([
        String(userId),
        IDIOMA_PADRAO,
        PAR_PAGINA,
        PAR_REGISTROS_PAGINA,
        "<#Filtro_ID_Empresa_Origem#>",
        "<#Filtro_ID_Empresa_Destino#>",
        "<#Filtro_ID_Categoria#>",
      ]),
    [userId]
  );

  const empresaOrigemProps = useMemo(
    () => ({
      value: "",
      type: "Combobox",
      title: "Empresa Origem",
      id: "Filtro_ID_Empresa_Origem",
      isDisabled: false,
      procedure: "SRM_Agendamento_Get_Empresas",
      procedureParams: [userId],
    }),
    [userId]
  );

  const empresaDestinoProps = useMemo(
    () => ({
      value: "",
      type: "Combobox",
      title: "Empresa Destino",
      id: "Filtro_ID_Empresa_Destino",
      isDisabled: false,
      procedure: "FRONT_Componente_Combo_Empresas",
      procedureParams: [String(userId), IDIOMA_PADRAO, "ORIGEM", "NF"],
    }),
    [userId]
  );

  const categoriaProps = useMemo(
    () => ({
      value: "",
      type: "Combobox",
      title: "Categoria",
      id: "Filtro_ID_Categoria",
      isDisabled: !hasOrigem,
      procedure: hasOrigem ? "FRONT_Workspace_DF_OT0016_Categorias" : "",
      procedureParams: [idOrigem],
      placeholder: hasOrigem
        ? "Selecione a categoria"
        : "Selecione a empresa origem",
    }),
    [hasOrigem, idOrigem]
  );

  return (
    <>
      <div className={`bg-white mb-3 card-content shadow-card p-3`}>
        <div className="row align-items-end gx-3">
          <div className="col-lg-3 col-md-6 col-12">
            <TranspaleStringToComponente
              elementId="Filtro_ID_Empresa_Origem"
              elementProps={empresaOrigemProps}
              preFilter={preFilter}
              onPreFilter={handleFilterChange}
            />
          </div>

          <div className="col-lg-3 col-md-6 col-12">
            <TranspaleStringToComponente
              elementId="Filtro_ID_Empresa_Destino"
              elementProps={empresaDestinoProps}
              preFilter={preFilter}
              onPreFilter={handleFilterChange}
            />
          </div>

          <div className="col">
            <TranspaleStringToComponente
              key={`categoria-${idOrigem}`}
              elementId="Filtro_ID_Categoria"
              elementProps={categoriaProps}
              preFilter={preFilter}
              onPreFilter={handleFilterChange}
            />
          </div>

          <div className="col-auto d-flex justify-content-end align-items-center gap-2 mb-3">
            <button
              type="button"
              className="btn btn-primary-dark text-white fw-semibold"
              onClick={handleNew}
            >
              Novo
            </button>
            <button
              type="button"
              className="btn btn-primary-dark text-white fw-semibold"
              onClick={handleSearch}
            >
              Pesquisar
            </button>
          </div>
        </div>
      </div>

      {showGrid && (
        <Row>
          <TableSimple
            dataKey="ID"
            procName={PROC_NAME_GRID}
            procParams={procParams}
            columnsList={COLUMNS_LIST}
            paramsOnFilter={paramsOnFilter}
            triggerOnFilter={triggerOnFilter}
            setTriggerOnFilter={setTriggerOnFilter}
            callbackTriggers={handleTriggers}
            enableMinHeight
          />
        </Row>
      )}

      <ModalIframePage
        openModal={openModalVisualization}
        onClosed={(isReloadPage) => {
          if (isReloadPage) setTriggerOnFilter(true);
          setOpenModalVisualization(false);
        }}
        triggerType={triggerType}
      />
    </>
  );
}

export default memo(GridBody);